export const config = {
  PROJECT_NAME: "SM26",
  ENVIRONMENT: "Prod",
  UserPoolClientId: "5t32sl33rtm3ikk091n3k10kjg",
  UserPoolId: "us-east-1_pPVOWZg7S",
  apiurl:
    "https://lmxhsmiuzjcyjlsbgh55j3jfky.appsync-api.us-east-1.amazonaws.com/graphql",
  CognitoIdentityPool: "us-east-1:f8c8b3cd-1fab-40ed-b843-6fe51eef2ff9",
  stripePublicKey:
    "pk_live_51KbcFTFnh9Dh90PAJX2on11DOhp1sG8NSaQAEUFaIxI2pU0AhAmklTMBNR14APMkgAufVhepL6MxP6QobGLepi3O00DFxy61C6",
  certArn: "arn:aws:acm:us-east-1:286439536257:certificate/524b2c8f-3968-40f8-ae77-8a59fcea588a",
  prices: [{"name":"diamond-monthly","priceId":"price_1KhFLSFnh9Dh90PAK4nxENOA"},{"name":"diamond-weekly","priceId":"price_1KhFLSFnh9Dh90PA7DrCKeFM"},{"name":"diamond-daily","priceId":"price_1KhFLSFnh9Dh90PAIVR6RCaK"},{"name":"gold-monthly","priceId":"price_1KhFNEFnh9Dh90PAfCfqn1yE"},{"name":"gold-weekly","priceId":"price_1KhFNEFnh9Dh90PAO84cxbBk"},{"name":"gold-daily","priceId":"price_1KhFNEFnh9Dh90PA3TfaEFjt"},{"name":"bronze-monthly","priceId":"price_1KhFPlFnh9Dh90PALZfFKY7u"},{"name":"bronze-weekly","priceId":"price_1KhFPlFnh9Dh90PAkNqGCWaM"},{"name":"bronze-daily","priceId":"price_1KhFPlFnh9Dh90PASz6ZDqoG"},{"name":"device","priceId":"price_1QzmmkFnh9Dh90PAQY31g5pn"}],
  portalConfiguration: "bpc_1NfTwtFnh9Dh90PAtiAxlpAV",
  connectionArn: "arn:aws:codestar-connections:us-east-1:286439536257:connection/11241028-e9a4-4225-b788-0e6b7c2876de",
  repo: "stubminer26",
  repoOwner: "murribu",
  branch: "main",
};
